var map = {
	"./google-laurel-da-DK.svg": 67807,
	"./google-laurel-de-DE.svg": 96061,
	"./google-laurel-en-GB.svg": 58703,
	"./google-laurel-en-US.svg": 1656,
	"./google-laurel-es-ES.svg": 47199,
	"./google-laurel-es-MX.svg": 75276,
	"./google-laurel-fr-FR.svg": 28019,
	"./google-laurel-it-IT.svg": 88837,
	"./google-laurel-nb-NO.svg": 92350,
	"./google-laurel-nl-NL.svg": 33163,
	"./google-laurel-pl-PL.svg": 48271,
	"./google-laurel-pt-BR.svg": 72783,
	"./google-laurel-pt-PT.svg": 85119,
	"./google-laurel-sv-SE.svg": 73550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;